import { ReactNode } from "react";

interface PanelCardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  noPadding?: boolean;
}

export default function PanelCard({
  children,
  className = "",
  title,
  subtitle,
  noPadding = false,
}: PanelCardProps) {
  return (
    <div
      className={`rounded-2xl border border-secondary/10 bg-white shadow-lg shadow-secondary/5 ${className}`}
    >
      {(title || subtitle) && (
        <div className="border-b border-secondary/10 px-5 py-4">
          {title && <h3 className="font-extrabold text-secondary">{title}</h3>}
          {subtitle && <p className="mt-0.5 text-xs text-secondary/50">{subtitle}</p>}
        </div>
      )}
      <div className={noPadding ? "" : "p-5"}>{children}</div>
    </div>
  );
}
